import React from 'react';

function CertificateStats({ stats }) {
  return (
    <div className="stats-grid">
      <div className="kpi-card kpi-valid">
        <div className="label">Valid Certificates</div>
        <div className="value">{stats?.valid || 0}</div>
      </div>
      <div className="kpi-card kpi-soon">
        <div className="label">Expiring soon (90 days)</div>
        <div className="value">{stats?.expiring || 0}</div>
      </div>
      <div className="kpi-card kpi-expired">
        <div className="label">Expired</div>
        <div className="value">{stats?.expired || 0}</div>
      </div>
      <div className="kpi-card kpi-total">
        <div className="label">Total Certificates</div>
        <div className="value">{stats?.total || 0}</div>
      </div>
    </div>
  );
}

export default CertificateStats;
